import store from "@/store"
import {
  ACTIONS as AUTHENTICATION_ACTIONS,
  NAMESPACE as AUTHENTICATION_NAMESPACE,
  STATE as AUTHENTICATION_STATE
} from "@/constants/vuex/authentication"
import {userLogout} from "@/services/userServices";
import {redirect} from "@/util/router_utils";
import {LOGIN} from "@/constants/router/routes";

let timerBeforeExpirationDialog = null
let timeCloseSession = null

const state = {
  modalVisible: false,
  loggedIn: false,
}

const mutations = {
  SET_MODAL_VISIBLE(state, value) {
    state.modalVisible = value
  },
  SET_LOGGED_IN(state, value) {
    state.loggedIn = value
  }
}

const actions = {
  startSessionTimer({ commit, state}) {
    const expirationMinutes = store.state[AUTHENTICATION_NAMESPACE][AUTHENTICATION_STATE.S_TOKEN_EXPIRATION]
    const sessionDurationMs = expirationMinutes * 60000
    const warningTimeBeforeExpire = 60000

    if (timerBeforeExpirationDialog) clearTimeout(timerBeforeExpirationDialog)
    if (timeCloseSession) clearTimeout(timeCloseSession)

    timeCloseSession = setTimeout(async () => {
      if (state.loggedIn) {
        await userLogout()
        await store.dispatch(`${AUTHENTICATION_NAMESPACE}/${AUTHENTICATION_ACTIONS.A_SET_LOGOUT_DATA}`)
        redirect(LOGIN)
      }
    }, sessionDurationMs - 5000 )

    timerBeforeExpirationDialog = setTimeout(() => {
      if(state.loggedIn) {
        commit('SET_MODAL_VISIBLE', true)
        localStorage.setItem('modal-event', 'true')
      }
    }, sessionDurationMs - warningTimeBeforeExpire)
  },

  async refreshSession({ commit, dispatch, state }) {
    try {
      if (state.loggedIn) {
        commit('SET_MODAL_VISIBLE', false)
        localStorage.setItem('modal-event', 'false')
        localStorage.setItem('session-refresh', JSON.stringify({ refresh: true, timestamp: Date.now() }))
        dispatch('startSessionTimer')
      }
    } catch (err) {
      console.error('[Vuex/session] Error al refrescar sesión', err)
    }
  },


  login({ commit, dispatch }) {
    commit('SET_LOGGED_IN', true)
    commit('SET_MODAL_VISIBLE', false)
    dispatch('startSessionTimer')
    localStorage.setItem('session-event', JSON.stringify({ loggedIn: true }))
  },

  async logout({commit}) {
    commit('SET_LOGGED_IN', false)
    commit('SET_MODAL_VISIBLE', false)
  },

  logoutOtherTabs() {
    localStorage.setItem('session-event', JSON.stringify({loggedIn: false}))
    localStorage.setItem('modal-event', 'false')
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


